import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";
import { PageHero, Reveal, SectionTag } from "../components/Reveal";

const Terminal = () => {
  const { t } = useLanguage();
  const p = t.terminal;

  const blocks = [
    { tag: p.sec1Tag, title: p.sec1Title, text: p.sec1Text, img: IMAGES.mapSatellite, cap: p.capSat },
    { tag: p.sec2Tag, title: p.sec2Title, text: p.sec2Text, img: IMAGES.mapBay, cap: p.capBay },
    { tag: p.sec3Tag, title: p.sec3Title, text: p.sec3Text, img: IMAGES.terminalOverview, cap: p.capAerial },
  ];

  return (
    <main data-testid="terminal-page">
      <PageHero chip={p.chip} title={p.title} sub={p.sub} testid="terminal-hero" />

      {/* hero set-piece: frontal do terminal */}
      <section className="px-6 lg:px-12 py-16 border-b border-ops">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <figure className="rounded-2xl overflow-hidden border border-ops">
              <div className="aspect-[21/9] overflow-hidden">
                <img src={IMAGES.terminalFront} alt={p.capFront} data-testid="terminal-front-image" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <figcaption className="px-5 py-3 text-[11px] mono-tag uppercase tracking-widest text-ops-muted border-t border-ops bg-ops-surface">
                {p.capFront}
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </section>

      {/* key message band */}
      <section className="px-6 lg:px-12 py-14 border-b border-ops bg-ops-core/20">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <p data-testid="terminal-key-message" className="font-display text-2xl sm:text-4xl font-extrabold uppercase text-white leading-tight border-l-2 border-ops-light pl-6">
              {p.keyMessage}
            </p>
          </Reveal>
        </div>
      </section>

      {/* alternating blocks */}
      {blocks.map((b, i) => (
        <section key={b.tag} data-testid={`terminal-block-${i}`} className={`px-6 lg:px-12 py-20 border-b border-ops ${i % 2 === 1 ? "bg-ops-panel/60" : ""}`}>
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className={`lg:col-span-5 space-y-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <SectionTag>{b.tag}</SectionTag>
              <Reveal>
                <h2 className="font-display text-2xl sm:text-4xl font-extrabold uppercase text-white leading-tight">{b.title}</h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="text-sm text-ops-muted leading-relaxed">{b.text}</p>
              </Reveal>
            </div>
            <Reveal delay={0.1} className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <figure className="rounded-xl overflow-hidden border border-ops">
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={b.img} alt={b.cap} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
                <figcaption className="px-4 py-3 text-[11px] mono-tag uppercase tracking-widest text-ops-muted border-t border-ops bg-ops-surface">
                  {b.cap}
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </section>
      ))}

      {/* papel da OPS */}
      <section className="px-6 lg:px-12 py-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 space-y-5">
            <SectionTag>{p.sec4Tag}</SectionTag>
            <Reveal>
              <h2 className="font-display text-2xl sm:text-4xl font-extrabold uppercase text-white leading-tight">{p.sec4Title}</h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-sm text-ops-muted leading-relaxed max-w-xl">{p.sec4Text}</p>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="p-10 rounded-2xl border border-ops bg-ops-surface flex items-center justify-center">
              <span className="bg-white rounded-xl px-6 py-4 inline-flex items-center">
                <img src={IMAGES.opsLogo} alt="Open Port Services" data-testid="terminal-ops-logo" className="h-16 w-auto" />
              </span>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Terminal;
